import { ColorDot } from './Status.styles';

type StatusTypeProps = {
	[key: string]: {
		color: string;
		label: string;
	};
};

export const statusType: StatusTypeProps = {
	finished: { label: 'Completo', color: '#8dc63f' },
	confirmed: { label: 'Confirmado', color: '#8dc63f' },
	active: { label: 'Activo', color: '#8dc63f' },
	inactive: { label: 'Inactivo', color: '#c22a58' },
	canceled: { label: 'Cancelado', color: '#c22a58' },
	complete: { label: 'Completo', color: '#8dc63f' },
	scheduled: { label: 'Programado', color: '#6850c2' },
	none: { label: 'Pendiente', color: '#5082c2' },
	declinado: { label: 'Declinado', color: '#c22a58' },
	pendent: { label: 'Pendiente', color: '#5082c2' },
	compatible: { label: 'Apto para puesto', color: '#8dc63f' },
	incompatible: { label: 'No apto para puesto', color: '#c22a58' },
	incomplete: { label: 'Incompleto', color: '#ffd642' },
	canceling: { label: 'En cancelación', color: '#ffd642' },
	partial: { label: 'Resultados parciales', color: '#1ab0e6' },
	appointmentRequested: { label: 'Cita solicitada', color: '#1ab0e6' },
	appointmentAccepted: { label: 'Cita aceptada', color: '#6850c2' },
	notapplied: { label: 'No aplicado', color: '#808080' },
	notCompleted: { label: 'No completado', color: '#c22a58' },
	queued: { label: 'Rever', color: '#ffd642' },
	noShow: { label: 'No se presentó', color: '#c22a58' },
	inProgress: { label: 'En progreso', color: '#6850c2' },
	processing: { label: 'En proceso', color: '#D8DEE6' },
	withoutSchedule: { label: 'Sin agendar', color: '#404D5C' },
	approved: { label: 'Aprobado', color: '#8dc63f' },
	rejected: { label: 'Declinado', color: '#c22a58' },
	notFinished: { label: 'No completado', color: '#c22a58' },
	withoutUnit: { label: 'Sin red disponible', color: '#6850c2' },
	low: {
		label: 'Bajo',
		color: '#1AE678',
	},
	medium: {
		label: 'Medio',
		color: '#F08B2D',
	},
	high: {
		label: 'Alto',
		color: '#c22a58',
	},
	finishedWithoutMedicalRecord: {
		label: 'Completo sin nota',
		color: '#8dc63f',
	},
	registered: {
		label: 'Se registró',
		color: '#8dc63f',
	},
	nonRegistered: {
		label: 'No se registró',
		color: '#c22a58',
	},
	notApplied: {
		label: 'No aplicado',
		color: '#808080',
	},
	pendingResult: {
		label: 'No acudió o pendiente de resultado',
		color: '#ffd642',
	},
	pending: {
		label: 'Pendiente registro',
		color: '#ffd642',
	},
	notParticipating: {
		label: 'No participará',
		color: '#F08B2D',
	},
};

type StatusProps = {
	status: string;
	statusList?: StatusTypeProps;
	hideLabel?: boolean;
};

export const Status = ({
	status,
	statusList,
	hideLabel,
}: StatusProps): JSX.Element => {
	const statusSource = statusList ?? statusType;

	return (
		<div key={statusSource[status]?.label || '-'}>
			{statusSource[status]?.color && (
				<ColorDot color={statusSource[status]?.color} />
			)}
			{!hideLabel && (statusSource[status]?.label || '-')}
		</div>
	);
};
